<template>

  <div>
  <duration-quick-settings
    :value="task_duration_remaining"
    @save="onQuickSetDurationRemaining($event)"
    :quickDurationSettings="{
      '0 min': 0 * 60,
      '1 min': 1 * 60,
      '3 min': 3 * 60,
      '5 min': 5 * 60,
      '10 min': 10 * 60,
      '15 min': 15 * 60,
      '20 min': 20 * 60,
      '25 min': 25 * 60,
      '30 min': 30 * 60,
      '45 min': 45 * 60,
      '1 h': 1 * 60 * 60,
      '2 h': 2 * 60 * 60,
      '3 h': 3 * 60 * 60,
      '4 h': 4 * 60 * 60,
      '8 h': 8 * 60 * 60,
    }">
    {{ task_duration_remaining | hoursMinutes }}
  </duration-quick-settings>
  <br />
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  props: {
    task: {
      type: Object
    },
    memberId: {
      required: true,
      type: String,
    },
    goalId: {
      required: true,
      type: String,
    },
    activeTask: {
      type: Object
    }
  },
  data() {
    return {
    }
  },
  computed: {
    ...mapGetters('session', [
      'session_timer_taskId',
      'session_time_elapsed',
      'session_system_time'
    ]),
    task_duration_remaining: {
      get() {
        return Math.max(0, this.task.durationRemaining - Math.min(this.activeTask.taskDuration,  this.session_system_time - this.activeTask.taskRecordingStartedAt.unix()))
      },
      set() {
      }
    }
  },
  methods: {

    onQuickSetDurationRemaining(value) {
      console.log('onQuickSetDurationRemaining', this.memberId, this.goalId, this.task.$id, value)
      this.$api.task_update({
        member_id:  this.memberId,
        goal_id:    this.goalId,
        task_id:    this.task.$id,
        data:       { durationRemaining: value }
      });
    },

  },
  components: {
  }
};
</script>

<style>
</style>
